// Mock data for PN0VΛ Music Portfolio

export const artistInfo = {
  name: "PN0VΛ",
  bio: "PN0VΛ is the production project of Peter Wilks, focused on crafting polished, vocal-driven pop with a strong emphasis on structure, emotion, and modern production. His work blends cinematic elements with clean, contemporary sound design, creating tracks that feel both immediate and intentional.\n\nWorking across multiple conceptual releases, he develops distinct sonic identities through carefully structured projects, building a cohesive and evolving catalog. His music is designed with both listening experience and performance potential in mind.",
  email: "contact.pn0va.music@gmail.com",
  socialMedia: {
    youtube: "https://www.youtube.com/@Pnov4",
    instagram: "https://instagram.com/p.n0v4"
  },
  logo: "https://customer-assets.emergentagent.com/job_music-portfolio-55/artifacts/nen4q40t_PN0v4.png"
};

export const mockEPs = [
  {
    id: "ep1",
    title: "Cosmic Dreams EP",
    description: "A journey through cinematic soundscapes",
    releaseDate: "2024",
    coverArt: "https://images.unsplash.com/photo-1614680376593-902f74cf0d41?w=800&h=800&fit=crop",
    tracks: [
      {
        id: "track1",
        title: "Starlight",
        duration: "3:42",
        youtubeUrl: "",
        audioUrl: ""
      },
      {
        id: "track2",
        title: "Nebula",
        duration: "4:15",
        youtubeUrl: "",
        audioUrl: ""
      },
      {
        id: "track3",
        title: "Gravity",
        duration: "3:58",
        youtubeUrl: "",
        audioUrl: ""
      }
    ]
  },
  {
    id: "ep2",
    title: "Neon Nights",
    description: "Vocal-driven pop with modern production",
    releaseDate: "2023",
    coverArt: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=800&h=800&fit=crop",
    tracks: [
      {
        id: "track4",
        title: "Electric Heart",
        duration: "3:28",
        youtubeUrl: "",
        audioUrl: ""
      },
      {
        id: "track5",
        title: "Midnight City",
        duration: "4:02",
        youtubeUrl: "",
        audioUrl: ""
      }
    ]
  },
  {
    id: "ep3",
    title: "Ethereal",
    description: "Structured emotion meets clean sound design",
    releaseDate: "2023",
    coverArt: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=800&h=800&fit=crop",
    tracks: [
      {
        id: "track6",
        title: "Aurora",
        duration: "3:55",
        youtubeUrl: "",
        audioUrl: ""
      },
      {
        id: "track7",
        title: "Reflection",
        duration: "4:20",
        youtubeUrl: "",
        audioUrl: ""
      },
      {
        id: "track8",
        title: "Horizon",
        duration: "3:45",
        youtubeUrl: "",
        audioUrl: ""
      }
    ]
  }
];
